import {
  Component,
  EventEmitter,
  Injector,
  Output,
  ViewChild,
} from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'changeUserRolesModal',
  templateUrl: './change-user-roles-modal.component.html',
  styleUrls: ['change-user-roles-modal.component.less'],
})
export class ChangeUserRolesModalComponent extends AppComponentBase {
  @ViewChild('modal', { static: true }) modal: ModalDirective;
  options: any;

  @Output() changeRole$: EventEmitter<any> = new EventEmitter<any>();

  constructor(injector: Injector) {
    super(injector);
  }

  show(options: any): void {
    this.options = options;
    this.modal.show();
  }
  close(): void {
    this.modal.hide();
  }

  change(): void {
    this.changeRole$.emit();
    this.modal.hide();
  }
}
